module.exports = __webpack_public_path__ + "static/media/calendar.75caea9b.svg";